import React from 'react'
import { useSelector } from 'react-redux'
import { STATICS } from 'statics'
import { Button } from '../../../button'
import './style.scss'

export function PaymentModal() {
  const { data } = useSelector(({ modal }) => modal)

  function handleClick() {
    window.open(data.paymentLink)
  }

  return (
    <div className='container-payment-modal'>
      <div className='container-icon'>
        <STATICS.INFO_TRIANGLE_ROUNDED />
      </div>
      <span className='text'>Você será redirecionado para concluir o pagamento.</span>
      <Button onClick={handleClick} className='button' color='primary'>
        Ir para pagamento {'>'}
      </Button>
    </div>
  )
}
